export default __webpack_public_path__ + "static/media/robinhood.68141f89.svg";